//changes from haseeb.

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { UsePortalApi } from "../../../utils/UsePortalApi";

export const Messaging = createAsyncThunk(
  "Messaging",
  async (payload, { dispatch, getState }) => {
    try {
      dispatch(gettingMessaging(""));
      const response = await UsePortalApi(
        `/Patient/Messaging`,
        "Post",
        payload,
        true
      );
      if (response) {
        console.log(response , "response")
        response[0].hasOwnProperty('entry') ? dispatch(gettingMessagingSuccess(response[0].entry)) : dispatch(gettingMessagingClear())

      } else {
        dispatch(
          gettingMessagingFailed(
            response?.errorMessage
          )
        );
      }
    } catch (error) {
      dispatch(gettingMessagingFailed(error));
    }
  }
);
// export const fetchMoreImmunefromApi = (pageSize, pageNumber) => {
//     return (dispatch) => {
//         dispatch(getImmune())
//         getUserId().then((userInfo) => {
//             const item = JSON.parse(userInfo);
//             const queryString = '?Token=' + item.token + '&PatientID='+item.userid+'&PageSize='+pageSize+'&PageNumber='+pageNumber+'&TypeID=0'
//             getAllImmune(queryString)
//                 .then(data => data.json())
//                 .then(json => {
//                     json[0].hasOwnProperty('entry') ? dispatch(getImmuneMoreSuccess(json[0].entry)) : dispatch(gettingMessagingClear())
//                 })
//                 .catch(err => dispatch(getImmuneFail(err)))
//         })
//     }
// }

const MessagingSlice = createSlice({
  name: "Messaging",
  initialState: {
    Messaging: null,
    isGetting: false,
    error: false,
  },
  reducers: {
    gettingMessaging: (state, action) => {
      state.Messaging = null;
      state.isGetting = true;
      state.error = false;
    },
    gettingMessagingSuccess: (state, action) => {
      state.Messaging = action.payload;
      state.isGetting = false;
      state.error = false;
    },
    gettingMessagingFailed: (state, action) => {
      state.Messaging = null;
      state.isGetting = false;
      state.error = true;
    },
    gettingMessagingClear: (state, action) => {
      state.Messaging = null;
      state.isGetting = false;
      state.error = false;
    },
  },
});
export const {
  gettingMessaging,
  gettingMessagingSuccess,
  gettingMessagingFailed,
  gettingMessagingClear,
} = MessagingSlice.actions;
export default MessagingSlice.reducer;
